export type CbIconProps = {
  width?: 16 | 24 | 32 | 40 | 48 | 56 | 64;
  color?: string;
};

export const cbIconDefaults = {
  width: 24 as const,
  color: "#5E6278",
};
